import type { GetApiV1RefundsMyRequests200AllOfThreeDataItem } from './getApiV1RefundsMyRequests200AllOfThreeDataItem';

export type GetApiV1RefundsMyRequests200AllOfThree = {
  data?: GetApiV1RefundsMyRequests200AllOfThreeDataItem[];
};
